import { render } from "./OdooContacts.vue?vue&type=template&id=4468a496&scoped=true"
import script from "./OdooContacts.vue?vue&type=script&lang=js"
export * from "./OdooContacts.vue?vue&type=script&lang=js"

import "./OdooContacts.vue?vue&type=style&index=0&id=4468a496&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4468a496"]])

export default __exports__